'use client';

import { useEffect, useState } from 'react';
import { getGppData, ONETRUST_CATEGORIES, onConsentChange } from 'libs/oneTrust';

const LIVERAMP_PARTNER_ID = 713261;
const LIVERAMP_PIXEL_BASE = 'https://idsync.rlcdn.com';

interface LiveRampPixelClientProps {
  anonymousId: string;
}

function buildPixelUrl(anonymousId: string): string {
  const base = `${LIVERAMP_PIXEL_BASE}/${LIVERAMP_PARTNER_ID}.gif?partner_uid=${encodeURIComponent(anonymousId)}`;
  const gpp = getGppData();
  if (!gpp) return base;
  return `${base}&gpp=${encodeURIComponent(gpp.gppString)}&gpp_sid=${gpp.sectionIds.join(',')}`;
}

/**
 * Renders the LiveRamp ID-sync pixel only when the user has consented to
 * Targeting (C0004). Subscribes to OneTrust via the central dispatcher so
 * the pixel mounts on initial consent and unmounts on mid-session revoke,
 * preventing any further network requests.
 */
export default function LiveRampPixelClient({ anonymousId }: LiveRampPixelClientProps) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    return onConsentChange(activeGroups => {
      if (!activeGroups.includes(ONETRUST_CATEGORIES.TARGETING)) {
        setSrc(null);
        return;
      }
      setSrc(buildPixelUrl(anonymousId));
    });
  }, [anonymousId]);

  if (!src) return null;

  return (
    // oxlint-disable-next-line nextjs/no-img-element
    <img
      id="liveramp-pixel"
      src={src}
      width="1"
      height="1"
      alt=""
      style={{ position: 'absolute', zIndex: -1, border: 0, height: 1 }}
    />
  );
}
